import React, { useState } from "react";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getSettings } from "../../Helpers/SettingsHelper";
import { Paths } from "../../Common/Paths";
import { Button, InputText, Card, ProgressBar } from "../../Common/Imports"
import { ApiResponse } from "../../Models/Classes";
import { useAxios } from "../../Helpers/AxiosHelper";

const ResetPasswordRequest: React.FC = () => {
    const AxiosHelper = useAxios();
    const { t } = useTranslation();
    const [email, setEmail] = useState<string>("");
    const [sendStatus, setSendStatus] = useState<boolean>(false);
    const [sendError, setSendErrors] = useState<string | null>(null);
    const navigate = useNavigate();
    const config = getSettings();
    const [showLoader, setShowLoader] = useState<boolean>(false);

    const NavigateTo = (path: string) => {
        navigate(Paths[path].value);
    };

    const handleResetPassword = async (event: React.FormEvent<HTMLFormElement>) => {
        setShowLoader(true);
        event.preventDefault();
        try {
            await AxiosHelper.get(`Auth/ForgotPassword/${encodeURIComponent(email)}`);
            setSendStatus(true);
            setSendErrors(null);
        } catch (error: unknown) {
            if (axios.isAxiosError(error)) {
                console.log(error.response?.data as ApiResponse<number>)
                switch (error.response?.data.code) {
                    case 10:
                        setSendErrors(t("Auth.ResetPasswordRequest.Errors.UserNotFound"));
                        break;
                    default:
                        setSendErrors(t("Common.Errors.SendEmail"));
                        break;
                }
            } else {
                console.log(error);
                setSendErrors(t("Common.Errors.SendEmail"));
            }
        } finally {
            setShowLoader(false);
        }
    };

    return (
        <div className="z-5 w-full lg:w-8 px-6 text-center mt-8" style={{ maxWidth: '400px' }}>
            <Card>
                <div className="w-full flex align-items-center justify-content-center">
                    <img src={config.settings.cdnUrl + Paths.Icon.value} alt="logo" className="w-6rem" />
                </div>
                <h1 className="text-4xl font-light mt-4 text-primary-500">
                    {t("Auth.ResetPasswordRequest.Header")}
                </h1>
                {
                    showLoader ? (
                        <>
                            <ProgressBar mode="indeterminate" style={{ height: '6px' }} />
                        </>
                    )
                        : <>
                            {sendError &&
                                <p className="text-danger">
                                    {t(sendError)}
                                </p>
                            }
                            {sendStatus ?
                                <>
                                    <div className="flex align-items-center justify-content-center mt-4 mb-5 gap-3 text-primary ">
                                        {t("Auth.ResetPasswordRequest.Success")}
                                    </div>
                                    <a onClick={() => NavigateTo('Login')} className="text-primary secondary-button cursor-pointer">
                                        {t("Auth.ResetPasswordRequest.Link")}
                                    </a>
                                </>
                                :
                                <>
                                    <p>
                                        {t("Auth.ResetPasswordRequest.SubHeader")}
                                    </p>
                                    <form onSubmit={handleResetPassword} className="mt-5 text-left">
                                        <label htmlFor="email" className="block mb-2" style={{ color: '#4c566a' }}>
                                            {t("Auth.Email")}
                                        </label>
                                        <InputText id="email" type="email" className="w-full" value={email} onChange={(e) => setEmail(e.target.value)} required />
                                        <div className="flex align-items-center justify-content-center mt-4 gap-3">
                                            <Button label={t("Auth.ResetPasswordRequest.Button")} type="submit" className="w-10rem"></Button>
                                            <a onClick={() => NavigateTo('Login')} className="text-primary secondary-button cursor-pointer">
                                                {t("Auth.ResetPasswordRequest.Link")}
                                            </a>
                                        </div>
                                    </form>
                                </>
                            }
                        </>
                }
            </Card>
        </div>
    )
};

export default ResetPasswordRequest;
